import axios from "axios";
import config from "./config";
import { jwtDecode } from "jwt-decode";
import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import { NETWORK_ERROR_PAGE_ROUTE, NOT_FOUND_ERROR_PAGE_ROUTE, SERVER_ERROR_PAGE_ROUTE } from "./constants";


export const isTokenExpired = (parsedToken) => {
  return Boolean(
    parsedToken?.exp && moment.unix(parsedToken.exp).isBefore(moment())
  );
};
const instance = axios.create({
  baseURL: config.baseURL,
});

const getAccessToken = () => {
  const authUser = localStorage.getItem("authUser");
  if (!authUser) return null;

  try {
    const parsedAuthUser = JSON.parse(authUser);
    return parsedAuthUser?.accessToken || null;
  } catch (error) {
    console.error("Error parsing authUser from localStorage", error);
    return null;
  }
};

const isAccessTokenUsable = (token) => {
  if (!token) return false;

  try {
    return !isTokenExpired(jwtDecode(token));
  } catch (error) {
    console.error("Error decoding access token", error);
    return false;
  }
};

instance.interceptors.request.use((requestConfig) => {
  const token = getAccessToken();
  if (isAccessTokenUsable(token)) {
    requestConfig.headers = {
      ...(requestConfig.headers || {}),
      Authorization: `Bearer ${token}`,
      "Content-Type": requestConfig.headers?.["Content-Type"] || "application/json",
    };
  }
  return requestConfig;
});


const AxiosInterceptor = ({ children }) => {
  const navigate = useNavigate();

  const [isAppReady, setIsAppReady] = React.useState(false);


  const getErrorStatusAndMessage = (error) => {
    const errorStatus = error?.response?.data?.status ?? error?.response?.status;
    const errorMessage = error?.response?.data?.message;
    return [errorStatus, errorMessage];
  };

  const handleError = (errorStatus, errorMessage) => {
    if (Boolean(errorStatus)) {
      switch (String(errorStatus)) {
        case "404":
          navigate(NOT_FOUND_ERROR_PAGE_ROUTE);
          break;
        case "500":
          navigate(SERVER_ERROR_PAGE_ROUTE);
          break;
        default:
          break;
      }
    } else {
      navigate(NETWORK_ERROR_PAGE_ROUTE);
    }
  };

  React.useEffect(() => {
    const responseInterceptor = instance.interceptors.response.use(
      (response) => response,
      (error) => {
        const [errorStatus, errorMessage] = getErrorStatusAndMessage(error);
        handleError(errorStatus, errorMessage);
        return Promise.reject(error);
      }
    );
    setIsAppReady(true);
    return () => {
      instance.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  //return isAppReady ? children : <Backdrop open={true} />;
  return children;
};

export { AxiosInterceptor };

export default instance;
